import React from 'react'
import { DatePicker } from 'antd'
import { isEmpty } from 'lodash'
import moment from 'moment'

const { RangePicker } = DatePicker

export const dateFilterMethod = (filter, row) => {
  if (isEmpty(filter.value)) return true
  return !isEmpty(row[filter.id]) && moment(row[filter.id]).isBetween(filter.value[0], filter.value[1], 'days', '[]')
}

function DateFilter({ onChange, filter }) {
  return <RangePicker onChange={(value) => onChange(value)} value={filter && filter.value} style={{ width: '100%' }} />
}

DateFilter.propTypes = {}
DateFilter.defaultProps = {}

export default DateFilter
